export default __webpack_public_path__ + "static/media/house.7e4b313d.png";